import { DraftInitiator } from '@shared/models/draft';

export interface SaveDraftItem {
  id: string;
  allIds: string[];
  initiator: DraftInitiator;
  dateStarted: string;
  requestType: string;
}
